import React, {useEffect, useState} from 'react';

import CategoriesFilter from './filters/CategoriesFilter/CategoriesFilter';
import FilterFavorites from './filters/FilterFavorites/FilterFavorites';
import MoreFilters from './filters/MoreFilters/MoreFilters';
import styles from './BubblesFilter.module.scss';
import InnerCircleFilter from './filters/InnerCircleFilter/InnerCircleFilter';
import AnimatedVisibility from '../../../../elements/AnimatedVisiblilty/AnimatedVisiblity';
import InnerCircleSubFilter from './filters/InnerCircleSubFilter/InnerCircleSubFilter';

import qaIcon from './filters/InnerCircleSubFilter/icon-quests.png';
import chatIcon from './filters/InnerCircleSubFilter/icon-chat.png';
import meetingIcon from './filters/InnerCircleSubFilter/icon-meeting.png';
import favoriteIcon from './filters/InnerCircleSubFilter/icon-favorite.png';

const animatedVisiblityProps = {
    visibleClassName: styles.visible,
    hiddenClassName: styles.hidden,
    showingClassName: styles.animated,
    hidingClassName: styles.animated,
};

const BubblesFilter = props => {
    const {className = '', event, filterParams, expandedBubble, onExpandFilterMenu, onProtectRegion} = props,
        [activeFilter, setActiveFilter] = useState(null),
        filterButtonProps = {
            event: event,
            filterParams: filterParams,
            activeFilter: activeFilter,
            onFilterActivation: setActiveFilter,
        },
        classes = [styles.BubblesFilter, className, filterParams ? styles.activeFilter : ''].join(' ');

    useEffect(() => {
        if (expandedBubble) setActiveFilter(null);
    }, [expandedBubble]);

    return (
        <>
            <AnimatedVisibility className={classes} visible={!filterParams?.connections} {...animatedVisiblityProps}>
                <InnerCircleFilter {...filterButtonProps} />
                <FilterFavorites {...filterButtonProps} />
                <CategoriesFilter {...filterButtonProps} onExpandFilterMenu={onExpandFilterMenu} onProtectRegion={onProtectRegion} />
                <MoreFilters event={event} onFilterActivation={setActiveFilter} />
            </AnimatedVisibility>
            <AnimatedVisibility className={classes} visible={filterParams?.connections} {...animatedVisiblityProps}>
                <InnerCircleSubFilter {...filterButtonProps} type="qa" icon={qaIcon} />
                <InnerCircleSubFilter {...filterButtonProps} type="chat" icon={chatIcon} />
                <InnerCircleSubFilter {...filterButtonProps} type="meeting" icon={meetingIcon} />
                <InnerCircleSubFilter {...filterButtonProps} type="favorite" icon={favoriteIcon} />
            </AnimatedVisibility>
        </>
    );
};

export default BubblesFilter;
